import { escapeHtml, externalLinkButton } from '../ui/dom.js';

export interface PowerShellItem {
  Title?: string;
  FileName?: string;
  Categories: (string | null)[];
  Description: (string | null)[];
  URL?: string;
  code?: string;
}

export interface PowerShellData {
  PowerShell?: PowerShellItem[];
}

export function renderPowerShellItems(items: PowerShellItem[]): string {
  return items
    .map((item) => {
      const link = item.URL ? ` ${externalLinkButton(item.URL)}` : '';
      const categories = item.Categories.filter((c): c is string => Boolean(c)).join(', ');
      const descriptions = item.Description.filter((d): d is string => Boolean(d))
        .map((d) => `<li>${escapeHtml(d)}</li>`)
        .join('');
      const descriptionBlock = descriptions
        ? `<h5>Description</h5><ul class="bullet-list">${descriptions}</ul>`
        : '';
      const copyButton = item.code
        ? `<wa-copy-button value="${escapeHtml(item.code)}"></wa-copy-button>`
        : '';
      const code = item.code
        ? `<pre><code class="language-powershell">${escapeHtml(item.code)}</code></pre>`
        : '';

      return `<wa-card appearance="outlined" class="section-card">
        <h4 slot="header">${escapeHtml(item.Title ?? '')}${link}</h4>
        <p><strong>FileName:</strong> ${escapeHtml(item.FileName ?? '')}</p>
        <p><strong>Categories:</strong> ${escapeHtml(categories)}</p>
        ${descriptionBlock}
        <p><strong>Code:</strong></p>
        <div class="code-block">${copyButton}${code}</div>
      </wa-card>`;
    })
    .join('');
}
